import { getFiles } from "apis/controllers/files";
import { confirmCopyFromFamilyApp, getApplication } from "apis/controllers/student-applications";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useLookup } from "src/context/lookupContext";
import { useLoading } from "src/hooks/useLoading";



const usePanelladikesApplicationDetails = () => {
    const [data, setData] = useState(null);
    const [files, setFiles] = useState(null);
    const { id } = useParams();
    const { setLoading } = useLoading();
    const [succeeded, setSucceeded] = useState(false);
    const form = useForm();
    const { setLookups } = useLookup();
    const [openCopyDialog, setOpenCopyDialog] = useState(false);



    const resetForm = async () => {
        try {
            setLoading(true);
            const res = await getApplication(id);

            // const resFiles = await getFiles({
            //   DataKey: "MHD_Application",
            //   DataValue: res?.data?.application?.typeId,
            //   RecordId: null,
            //   RecordGuid: id,
            //   ProjectTableId: 4,
            // });
            // setFiles(resFiles?.data);
            form.reset({});
            setData(res?.data);
            form.setValue("applicant", res?.data?.application?.applicant);
            form.setValue("reviews", res?.data?.application?.reviews);
            form.setValue("childrenIbans", res?.data?.application?.childrenIbans)
            setLookups(res?.data?.lookups || {});
            setSucceeded(res?.status === "success");
        } catch (e) {

            console.log(e)
        }
        setLoading(false);
    };

    const fetchApplication = async () => {
        try {
            setLoading(true);

            setData(null);
            setSucceeded(false);
            const res = await getApplication(id);
            // const resFiles = await getFiles({
            //   DataKey: "MHD_Application",
            //   DataValue: res?.data?.application?.typeId,
            //   RecordId: null,
            //   RecordGuid: id,
            //   ProjectTableId: 4,
            // });
            form.reset({});
            setData(res?.data);
            form.setValue("applicant", res?.data?.application?.applicant);
            form.setValue("reviews", res?.data?.application?.reviews);
            form.setValue("childrenIbans", res?.data?.application?.childrenIbans)
            setLookups(res?.data?.lookups || {});
            setSucceeded(res?.status === "success");

            if (res?.data?.application?.settings?.canCopyData) setOpenCopyDialog(true)
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };
    const confirmCopy = async (copyData) => {
        await confirmCopyFromFamilyApp({ id, copyData })
        if (copyData) fetchApplication()
    }

    useEffect(() => {
        fetchApplication();
    }, []);

    return {
        form,
        data,
        succeeded,
        files,
        fetchApplication,
        resetForm,
        openCopyDialog,
        setOpenCopyDialog,
        confirmCopy
    };
};

export default usePanelladikesApplicationDetails;
